import { useState } from 'preact/hooks';

export interface LeadSubmit {
  email: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  company?: string;
  notes?: string;
}

interface Props {
  copy: string;
  onSubmit: (lead: LeadSubmit) => Promise<void>;
  onCancel: () => void;
}

export function LeadForm({ copy, onSubmit, onCancel }: Props) {
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [company, setCompany] = useState('');
  const [phone, setPhone] = useState('');
  const [notes, setNotes] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const submit = async (e: Event) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      setErr('Please enter a valid email.');
      return;
    }
    setBusy(true);
    setErr(null);
    try {
      await onSubmit({
        email: email.trim(),
        firstName: firstName.trim() || undefined,
        lastName: lastName.trim() || undefined,
        company: company.trim() || undefined,
        phone: phone.trim() || undefined,
        notes: notes.trim() || undefined
      });
    } catch {
      setErr("Sorry — we couldn't submit that. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form class="vc-lead" onSubmit={submit} novalidate>
      <p class="vc-lead-copy">{copy}</p>
      <div class="vc-lead-grid">
        <input placeholder="First name" value={firstName}
               onInput={(e) => setFirstName((e.target as HTMLInputElement).value)} />
        <input placeholder="Last name" value={lastName}
               onInput={(e) => setLastName((e.target as HTMLInputElement).value)} />
        <input type="email" placeholder="Work email" required value={email}
               onInput={(e) => setEmail((e.target as HTMLInputElement).value)} style={{ gridColumn: 'span 2' }} />
        <input placeholder="Company" value={company}
               onInput={(e) => setCompany((e.target as HTMLInputElement).value)} />
        <input placeholder="Phone (optional)" value={phone}
               onInput={(e) => setPhone((e.target as HTMLInputElement).value)} />
        <textarea placeholder="Anything we should know?" value={notes}
                  onInput={(e) => setNotes((e.target as HTMLTextAreaElement).value)} />
        {err && <div class="vc-error" style={{ gridColumn: 'span 2' }}>{err}</div>}
        <div class="vc-lead-row">
          <button type="button" class="vc-lead-cancel" onClick={onCancel} disabled={busy}>Not now</button>
          <button type="submit" class="vc-lead-submit" disabled={busy}>
            {busy ? 'Sending…' : 'Submit'}
          </button>
        </div>
      </div>
    </form>
  );
}
